module.exports = __webpack_public_path__ + "static/media/logo-feeder-large.5e59cc5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-feeder-large.png
// module id = 537
// module chunks = 0